var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlantThinking = function SvgPlantThinking(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 854 993",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_11958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.223 445.593C275.651 402.05 250.702 368.054 215.858 349.805",
    stroke: "#98A850",
    strokeWidth: 3.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.435 331.248C130.385 373.021 205.078 408.094 225.291 359.161C243.503 315.04 150.791 295.867 141.435 331.248Z",
    fill: "#376E44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M547.818 891.077C582.123 900.009 596.253 919.374 555.095 931.117C512.012 942.436 450.256 940.357 404.593 935.775C380.606 932.965 321.468 923.879 351.23 898.815C402.514 874.098 491.452 876.947 547.857 891.077H547.818Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.521 585.041C558.521 585.041 488.333 578.842 414.371 589.43C340.41 600.056 264.793 628.7 264.793 628.7C264.793 628.7 300.792 659.269 419.146 643.907C537.499 628.546 558.521 585.041 558.521 585.041Z",
    fill: "#3D8FC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.518 596.244C555.518 596.244 498.381 592.664 424.459 603.29C350.497 613.916 266.448 632.973 266.448 632.973C266.448 632.973 302.871 672.513 421.224 657.113C539.578 641.751 555.518 596.244 555.518 596.244Z",
    fill: "#715848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.821 694.766C550.821 694.766 626.477 765.721 618.622 787.358C605.763 822.894 534.188 864.397 534.188 864.397",
    stroke: "#48A8E4",
    strokeWidth: 7.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.113 638.401C425.113 638.401 417.374 546.771 385.572 504.729C343.721 449.366 273.879 412.06 269.952 413.215C266.024 414.37 343.49 476.894 371.211 517.088C395.467 552.238 410.213 641.443 410.213 641.443L425.113 638.44V638.401Z",
    fill: "#473C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.617 884.454L564.72 855.81",
    stroke: "#48A8E4",
    strokeWidth: 7.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.788 911.251L342.451 895.004",
    stroke: "#48A8E4",
    strokeWidth: 7.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.761 589.93C619.123 659.23 566.568 852.423 541.889 897.622C507.276 913.176 418.722 932.118 371.058 924.726C337.369 882.876 242.886 729.723 257.94 638.555C258.826 633.242 263.061 627.467 268.451 628.237C379.528 644.6 499.383 610.489 554.825 585.233C559.022 583.308 563.989 586.272 566.761 589.891",
    fill: "#86C5ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.94 638.555C258.826 633.242 263.061 627.467 268.451 628.237C272.34 628.815 276.228 629.315 280.117 629.739C268.644 724.949 361.047 877.679 398.625 926.304C388.576 926.42 379.181 925.958 371.058 924.687C337.369 882.838 242.886 729.685 257.94 638.517V638.555Z",
    fill: "#7CC2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.275 590.276C547.395 588.582 551.245 586.927 554.826 585.271C559.022 583.346 563.989 586.311 566.761 589.93C619.123 659.23 566.568 852.423 541.889 897.622C535.729 900.394 527.836 903.281 518.788 906.092C545.932 846.032 592.172 662.849 543.314 590.276H543.275Z",
    fill: "#7CC2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.977 936.66C479.863 924.61 564.72 855.81 564.72 855.81",
    stroke: "#48A8E4",
    strokeWidth: 7.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.516 929.577C464.501 937.816 342.489 895.004 342.489 895.004",
    stroke: "#48A8E4",
    strokeWidth: 7.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.119 715.324C396.468 723.217 402.782 728.26 408.249 726.566C413.716 724.872 416.219 717.057 413.871 709.164C411.522 701.272 405.208 696.228 399.74 697.961C394.312 699.655 391.771 707.47 394.119 715.363",
    fill: "#1A74AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.91 692.032C490.258 699.963 496.611 705.007 502.078 703.313C507.545 701.58 510.087 693.765 507.699 685.834C505.351 677.903 498.998 672.859 493.531 674.592C488.064 676.324 485.523 684.14 487.91 692.032Z",
    fill: "#1A74AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.023 660.731C496.148 660.539 506.197 660.693 512.627 671.665",
    stroke: "#1A74AD",
    strokeWidth: 3.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.993 710.55C380.105 702.889 383.532 690.222 397.931 684.601",
    stroke: "#1A74AD",
    strokeWidth: 3.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.902 776.77C444.172 771.188 449.678 767.068 454.49 765.143C468.274 759.137 481.557 762.833 495.302 757.289C492.799 768.031 479.632 771.842 470.314 773.036C460.997 774.768 452.334 772.112 443.902 776.77Z",
    fill: "#1A74AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.971 496.375C329.592 435.429 211.431 504.113 187.906 567.638",
    stroke: "#98A850",
    strokeWidth: 4.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.134 570.449C332.902 526.906 237.418 564.212 169.348 649.567",
    stroke: "#98A850",
    strokeWidth: 4.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.004 471.542C348.764 448.365 266.641 454.564 224.559 493.41",
    stroke: "#98A850",
    strokeWidth: 4.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.968 460.801C298.597 427.344 213.547 403.359 153.793 409.134",
    stroke: "#98A850",
    strokeWidth: 3.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.088 516.01C365.128 464.574 306.105 439.664 243.386 445.401",
    stroke: "#98A850",
    strokeWidth: 4.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.131 538.956C345.146 476.509 334.596 554.895 332.902 588.659",
    stroke: "#98A850",
    strokeWidth: 4.62,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.256 527.598C384.379 472.774 434.161 380.913 495.225 386.958",
    stroke: "#98A850",
    strokeWidth: 3.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.914 343.53C390.076 366.053 432.967 485.172 506.043 411.098C581.352 334.829 447.02 321.585 418.914 343.53Z",
    fill: "#488857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.836 705.815C200.149 724.641 293.862 648.873 188.021 601.942C93.6927 560.131 101.162 680.597 157.836 705.815Z",
    fill: "#376E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.311 523.325C422.034 494.566 504.427 505.808 537.076 530.987",
    stroke: "#98A850",
    strokeWidth: 3.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.282 547.965C512.705 578.033 634.409 546.579 551.361 481.745C465.695 414.87 443.095 522.093 475.282 547.965Z",
    fill: "#376E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.699 485.402C329.86 439.664 312.227 373.059 353.654 311.344",
    stroke: "#98A850",
    strokeWidth: 3.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68 268.955C322.854 254.364 298.136 344.261 358.121 352.308C401.782 358.16 415.296 278.965 377.68 268.955Z",
    fill: "#488857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.441 561.748C511.202 549.813 527.219 406.554 421.532 425.342C313.574 444.515 368.438 575.723 445.441 561.748Z",
    fill: "#488857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.7 448.173C309.416 394.697 306.644 341.105 315.615 287.089",
    stroke: "#98A850",
    strokeWidth: 3.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.499 275.501C269.528 274.923 272.069 355.157 321.967 362.742C355.117 367.785 364.281 273.422 315.499 275.501Z",
    fill: "#376E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.796 465.844C347.534 432.503 346.032 390.076 376.795 364.243",
    stroke: "#98A850",
    strokeWidth: 3.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.798 432.58C433.969 421.492 446.79 296.906 359.738 314.424C270.877 332.326 316.386 445.555 379.798 432.58Z",
    fill: "#376E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.382 438.51C290.396 394.928 274.572 346.726 244.888 307.764",
    stroke: "#98A850",
    strokeWidth: 3.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.931 244.469C175.739 261.217 205.693 345.801 258.517 319.159C300.291 298.1 250.547 227.568 212.931 244.469Z",
    fill: "#488857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.147 595.435C264.37 597.745 296.595 464.882 199.032 470.58C110.402 475.777 133.464 593.164 198.147 595.435Z",
    fill: "#376E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.11 544.885C339.833 541.073 349.921 420.568 263.177 428.461C183.979 435.66 179.936 550.198 273.11 544.885Z",
    fill: "#4A8759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3865 396.429C100.969 451.869 187.367 463.227 179.474 408.788C171.851 356.235 92.1909 364.513 95.3865 396.429Z",
    fill: "#488857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.292 688.182C397.663 679.827 439.167 553.817 323.778 563.172C205.809 572.72 254.206 699.693 337.292 688.182Z",
    fill: "#458955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.623 787.357C607.804 823.74 554.402 853.847 548.781 847.148",
    stroke: "#48A8E4",
    strokeWidth: 7.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.272 757.251C319.272 757.251 388.306 826.628 389.653 832.596C391.001 838.563 471.2 798.215 471.2 776.771",
    stroke: "#48A8E4",
    strokeWidth: 7.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_11958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 993,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlantThinking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "plant-thinking.476f7b4d3cd44c32509f85396b7a8115.svg";